(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-gallery"] && !Shopify.designMode) return;
  try {
    const productCardHoverVideoSelector = '.card-gallery video.product-media__hover-video';

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

    const gallery = event.target.closest('.card-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;

    requestAnimationFrame(() => {
      if (!gallery.matches(':hover')) return;

      const activeSlide = gallery.querySelector('slideshow-slide[aria-hidden="false"]');
      const video = activeSlide?.querySelector(productCardHoverVideoSelector);
      if (video instanceof HTMLVideoElement) {
        video.play().catch(() => {});
      }
    });
  });

  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;

    const gallery = event.target.closest('.card-gallery');
    if (!gallery || gallery.contains(event.relatedTarget)) return;

    for (const video of gallery.querySelectorAll(productCardHoverVideoSelector)) {
      if (!(video instanceof HTMLVideoElement)) continue;
      video.pause();
      video.currentTime = 0;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('yc-mobile-menu-position')) {
    customElements.define('yc-mobile-menu-position', class extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('header-drawer');
        this.header = this.closest('header-component');
        this.rootDetails = this.drawer.querySelector('.menu-drawer-container');
        this.update = () => {
          if (!this.rootDetails.open || !this.header) return;
          const top = Math.max(0, this.header.getBoundingClientRect().bottom);
          this.drawer.style.setProperty('--yc-mobile-menu-top', `${top}px`);
        };
        this.escape = (event) => {
          const branch = event.target.closest('.yc-mobile-menu__branch');
          if (event.key !== 'Escape' || !branch) return;
          event.stopPropagation();
          branch.open = false;
          branch.querySelector('summary').focus();
        };
        this.rootDetails.addEventListener('toggle', this.update);
        this.drawer.addEventListener('keyup', this.escape, true);
        window.addEventListener('resize', this.update, { passive: true });
        window.addEventListener('scroll', this.update, { passive: true });
        this.observer = new ResizeObserver(this.update);
        if (this.header) this.observer.observe(this.header);
        this.update();
      }
      disconnectedCallback() {
        this.rootDetails?.removeEventListener('toggle', this.update);
        this.drawer?.removeEventListener('keyup', this.escape, true);
        window.removeEventListener('resize', this.update);
        window.removeEventListener('scroll', this.update);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["yc-cart-goal-upsell"] && !Shopify.designMode) return;
  try {
    class YCCartGoalUpsell extends HTMLElement {
    #abortController;
    #observer;
    #renderQueued = false;

    connectedCallback() {
      this.#abortController?.abort();
      this.#abortController = new AbortController();
      this.addEventListener('click', this.#handleClick, { signal: this.#abortController.signal });
      this.#observeData();
      this.refresh();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#observer?.disconnect();
    }

    refresh() {
      this.#scheduleRender();
    }

    #observeData() {
      this.#observer?.disconnect();
      this.#observer = new MutationObserver((mutations) => {
        const dataChanged = mutations.some((mutation) => {
          const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
          if (target?.closest('[data-yc-cart-goal-output]')) return false;
          if (target?.closest('[data-yc-cart-goal-data]')) return true;
          return Array.from(mutation.addedNodes).some(
            (node) => node instanceof Element && (node.matches('[data-yc-cart-goal-data]') || node.querySelector('[data-yc-cart-goal-data]'))
          );
        });
        if (dataChanged) this.#scheduleRender();
      });
      this.#observer.observe(this, { childList: true, subtree: true, characterData: true });
    }

    #scheduleRender() {
      if (this.#renderQueued) return;
      this.#renderQueued = true;
      requestAnimationFrame(() => {
        this.#renderQueued = false;
        if (!this.isConnected) return;
        this.#render();
      });
    }

    #readData() {
      const dataNode = this.querySelector('[data-yc-cart-goal-data]');
      if (!(dataNode instanceof HTMLScriptElement)) return null;
      try {
        return JSON.parse(dataNode.textContent || '{}');
      } catch (error) {
        return null;
      }
    }

    #getThreshold(baseThreshold, currency) {
      const normalizedCurrency = String(currency || '').toUpperCase();
      if (normalizedCurrency === 'USD') return Number(baseThreshold || 0);
      const activeCurrency = String(window.Shopify?.currency?.active || '').toUpperCase();
      const rate = Number(window.Shopify?.currency?.rate || 0);
      if (activeCurrency !== normalizedCurrency || !Number.isFinite(rate) || rate <= 0) return null;
      return Math.ceil(Number(baseThreshold || 0) * rate);
    }

    #formatMoney(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || undefined, {
          style: 'currency',
          currency: currency || 'USD',
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      }
    }

    #escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    #selectRecommendations(data, gap) {
      const cartHandles = new Set(Array.isArray(data.cartHandles) ? data.cartHandles : []);
      const candidates = [];

      for (const product of Array.isArray(data.products) ? data.products : []) {
        if (!product?.handle || cartHandles.has(product.handle)) continue;
        const variants = (Array.isArray(product.variants) ? product.variants : [])
          .filter((variant) => Number(variant?.price || 0) >= gap)
          .sort((a, b) => Number(a.price) - Number(b.price));
        const variant = variants[0];
        if (!variant) continue;
        candidates.push({
          ...product,
          variant,
          overshoot: Number(variant.price) - gap,
        });
      }

      if (!candidates.length) return [];
      const minimumOvershoot = Math.min(...candidates.map((candidate) => candidate.overshoot));
      const tolerance = Math.min(2000, Math.max(500, Math.round(gap * 0.25)));
      const nearFit = candidates.filter((candidate) => candidate.overshoot <= minimumOvershoot + tolerance);

      nearFit.sort(
        (a, b) =>
          Number(a.rank || Number.MAX_SAFE_INTEGER) - Number(b.rank || Number.MAX_SAFE_INTEGER) ||
          a.overshoot - b.overshoot
      );

      const limit = this.dataset.context === 'drawer' ? 2 : 3;
      return nearFit.slice(0, limit);
    }

    #render() {
      const output = this.querySelector('[data-yc-cart-goal-output]');
      const data = this.#readData();
      if (!(output instanceof HTMLElement) || !data) {
        this.hidden = true;
        return;
      }

      const currency = String(data.currency || 'USD').toUpperCase();
      const cartTotal = Number(data.cartTotal || 0);
      const freeThreshold = this.#getThreshold(data.freeShippingThresholdUsdCents, currency);
      const giftThreshold = this.#getThreshold(data.giftThresholdUsdCents, currency);
      if (!Number.isFinite(freeThreshold) || !Number.isFinite(giftThreshold) || freeThreshold <= 0 || giftThreshold <= freeThreshold) {
        output.replaceChildren();
        this.hidden = true;
        return;
      }

      let goal;
      if (cartTotal < freeThreshold) {
        goal = {
          type: 'shipping',
          threshold: freeThreshold,
          title: data.copy?.shippingTitle,
          note: data.copy?.shippingNote,
        };
      } else if (cartTotal < giftThreshold) {
        goal = {
          type: 'gift',
          threshold: giftThreshold,
          title: data.copy?.giftTitle,
          note: data.copy?.giftNote,
        };
      } else {
        output.replaceChildren();
        this.hidden = true;
        return;
      }

      const gap = goal.threshold - cartTotal;
      const recommendations = this.#selectRecommendations(data, gap);
      if (!recommendations.length) {
        output.replaceChildren();
        this.hidden = true;
        return;
      }

      const amount = this.#formatMoney(gap, currency);
      const note = this.#escapeHtml(goal.note || '').replace(
        '__AMOUNT__',
        `<strong class="yc-cart-goal__amount">${this.#escapeHtml(amount)}</strong>`
      );
      const headingId = this.getAttribute('aria-labelledby') || '';

      output.innerHTML = `
        <div class="yc-cart-goal__header">
          <p class="yc-cart-goal__title" id="${this.#escapeHtml(headingId)}">${this.#escapeHtml(goal.title)}</p>
          <p class="yc-cart-goal__note">${note}</p>
        </div>
        <div class="yc-cart-goal__list">
          ${recommendations
            .map((product) => {
              const image = product.imageUrl
                ? `<img class="yc-cart-goal__image" src="${this.#escapeHtml(product.imageUrl)}" alt="${this.#escapeHtml(product.imageAlt || product.title)}" width="54" height="54" loading="lazy">`
                : '';
              const variantTitle =
                product.variant?.title && product.variant.title !== 'Default Title'
                  ? ` · ${this.#escapeHtml(product.variant.title)}`
                  : '';
              const addLabel = String(data.copy?.addProduct || '')
                .replace('__PRODUCT__', product.title || '')
                .trim();
              return `
                <article class="yc-cart-goal__card">
                  <a class="yc-cart-goal__media" href="${this.#escapeHtml(product.url)}" tabindex="-1" aria-hidden="true">${image}</a>
                  <span class="yc-cart-goal__copy">
                    <span class="yc-cart-goal__badge">${this.#escapeHtml(data.copy?.bestseller)}</span>
                    <a class="yc-cart-goal__name" href="${this.#escapeHtml(product.url)}">${this.#escapeHtml(product.title)}</a>
                    <span class="yc-cart-goal__meta">${this.#escapeHtml(this.#formatMoney(product.variant.price, currency))}${variantTitle}</span>
                  </span>
                  <button
                    class="yc-cart-goal__add"
                    type="button"
                    data-yc-cart-goal-add
                    data-variant-id="${this.#escapeHtml(product.variant.id)}"
                    data-source="cart_goal_${this.#escapeHtml(goal.type)}"
                    aria-label="${this.#escapeHtml(addLabel)}"
                  >${this.#escapeHtml(data.copy?.add)}</button>
                </article>
              `;
            })
            .join('')}
        </div>
      `;
      this.hidden = false;
    }

    #getSectionIds() {
      return [
        ...new Set(
          Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
            .map((component) => component.dataset.sectionId)
            .filter(Boolean)
        ),
      ];
    }

    #setStatus(message) {
      const status = this.querySelector('[data-yc-cart-goal-status]');
      if (status instanceof HTMLElement) status.textContent = message || '';
    }

    #handleClick = (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-yc-cart-goal-add]') : null;
      if (!(button instanceof HTMLButtonElement) || !this.contains(button)) return;
      this.#addVariant(button);
    };

    async #addVariant(button) {
      const variantId = Number(button.dataset.variantId || 0);
      if (!variantId || button.disabled) return;

      const data = this.#readData();
      const originalText = button.textContent;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = data?.copy?.adding || originalText;
      this.#setStatus(data?.copy?.adding);

      try {
        const sectionIds = this.#getSectionIds();
        const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            items: [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  _yc_upsell_source: button.dataset.source || 'cart_goal',
                },
              },
            ],
            sections: sectionIds.join(','),
            sections_url: window.location.pathname,
          }),
        });
        const payload = await response.json();
        if (!response.ok || payload.status) throw new Error(payload.description || payload.message || 'Unable to add');

        document.dispatchEvent(
          new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: payload,
              sourceId: 'yc-cart-goal-upsell',
              data: {
                source: 'yc-cart-goal-upsell',
                sections: payload.sections || {},
                itemCount: 1,
              },
            },
          })
        );

        button.textContent = data?.copy?.added || originalText;
        this.#setStatus(data?.copy?.added);
      } catch (error) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = data?.copy?.tryAgain || originalText;
        this.#setStatus(data?.copy?.tryAgain);
        return;
      }

      window.setTimeout(() => {
        if (!button.isConnected) return;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        button.textContent = originalText;
      }, 1200);
    }
  }

  if (!customElements.get('yc-cart-goal-upsell')) {
    customElements.define('yc-cart-goal-upsell', YCCartGoalUpsell);

    let refreshFrame = 0;
    const refreshCartGoalUpsells = () => {
      refreshFrame = 0;
      document
        .querySelectorAll('yc-cart-goal-upsell')
        .forEach((element) => element.refresh());
    };
    const queueCartGoalRefresh = () => {
      if (refreshFrame) return;
      refreshFrame = requestAnimationFrame(refreshCartGoalUpsells);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', queueCartGoalRefresh, { once: true });
    } else {
      queueCartGoalRefresh();
    }

    document.addEventListener('cart:update', queueCartGoalRefresh);
    document.addEventListener('shopify:section:load', queueCartGoalRefresh);
    document.addEventListener(
      'click',
      (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (target?.closest('[data-testid="cart-drawer-trigger"]')) {
          queueCartGoalRefresh();
        }
      },
      { capture: true }
    );

    const cartGoalObserver = new MutationObserver((mutations) => {
      const goalDataChanged = mutations.some((mutation) => {
        const target = mutation.target instanceof Element ? mutation.target : mutation.target.parentElement;
        if (target?.closest('[data-yc-cart-goal-output]')) return false;
        if (target?.closest('[data-yc-cart-goal-data]')) return true;

        return Array.from(mutation.addedNodes).some(
          (node) =>
            node instanceof Element &&
            (
              node.matches('yc-cart-goal-upsell, [data-yc-cart-goal-data]') ||
              node.querySelector('yc-cart-goal-upsell, [data-yc-cart-goal-data]')
            )
        );
      });
      if (goalDataChanged) queueCartGoalRefresh();
    });
    cartGoalObserver.observe(document.documentElement, { childList: true, subtree: true });
  }
  } catch(e) { console.error(e); }
})();

})();
